import { Box, Button, Modal, Stack, Typography } from "@mui/material";
import React from "react";
import { English } from "../../constant/EnglishFallback";
import { useSelector } from "react-redux";

const VerifyEmailModal = ({ onOpen, onClose }) => {
  const { multiLanguageData } = useSelector((state) => state?.main);

  const {
    TEXT_ALERT_VERIFY_EMAIL = English?.Profile?.TEXT_ALERT_VERIFY_EMAIL,
    BUTTON_OK = English?.Profile?.BUTTON_OK
  } = multiLanguageData?.Profile || {};

  return (
    <Modal open={onOpen} onClose={onClose}>
      <Box className="user-modal-responsive" sx={{ padding: "20px", width: "400px" }}>
        <Stack gap={2}>
          <Typography variant="body1">{TEXT_ALERT_VERIFY_EMAIL}</Typography>
          <div style={{ display: "flex", justifyContent: "end" }}>
            <Button variant="outlined" color="primary" onClick={onClose}>
              <b>{BUTTON_OK}</b>
            </Button>
          </div>
        </Stack>
      </Box>
    </Modal>
  );
};

export default VerifyEmailModal;
